import { render, staticRenderFns } from "./TableTemp.vue?vue&type=template&id=2e61dfa0&scoped=true&"
import script from "./TableTemp.vue?vue&type=script&lang=js&"
export * from "./TableTemp.vue?vue&type=script&lang=js&"
import style0 from "./TableTemp.vue?vue&type=style&index=0&id=2e61dfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61dfa0",
  null
  
)

export default component.exports